import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./authentication/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./authentication/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./authentication/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },
  {
    path: 'otp-verification',
    loadComponent: () =>
      import('./authentication/otp-varification/otp-varification.component').then(
        (m) => m.OtpVarificationComponent
      ),
  },
  {
    path: 'syncinns-admin',
    loadChildren: () => import('./after-login/after-login.routes').then((m) => m.afterLoginRoutes),
  },
];
